export const defaultChartButtons = `[
    {
        "type": "week",
        "count": 1,
        "text": "1W",
        "title": "View 1 week"
    },
    {
        "type": "month",
        "count": 1,
        "text": "1M",
        "title": "View 1 month"
    },
    {
        "type": "ytd",
        "text": "YTD",
        "title": "View year to date"
    },
    {
        "type": "year",
        "count": 1,
        "text": "1Y",
        "title": "View 1 year"
    },
    {
        "type": "year",
        "count": 5,
        "text": "5Y",
        "title": "View 5 years"
    },
    {
        "type": "year",
        "count": 10,
        "text": "10Y",
        "title": "View 10 years"
    },
    {
        "type": "all",
        "text": "All",
        "title": "View all"
    }
]`;
